import { createEntityAdapter } from "@reduxjs/toolkit"
import { createAppSlice } from "../../app/createAppSlice"

//entity: {  id: targetFoi,  for EvidenceVariable
//  title: string,
// code: CodeableConcept for Summary of net effect contribution for single entry
// focus: Reference to EvidenceVariable,
// section: array 0-6,
// itemChanged: boolean
// 
//key uses: Summary of Net Effect

const netEffectContributionsAdapter = createEntityAdapter({
    sortComparer: (b, a) => {
        if (b?.targetFoi && a?.targetFoi && b.targetFoi !== a.targetFoi) {
            return b.targetFoi.localeCompare(a.targetFoi)
        } else {
            return 0
        }
    }
})

const initialState = netEffectContributionsAdapter.getInitialState({
    status: 'idle'
})

const netEffectContributionsSlice = createAppSlice({
    name: "netEffectContributions",
    initialState,
    reducers: create => ({
        netEffectContributionAdded: create.preparedReducer(
            (contributionBody) => {
                return {
                    payload: {
                        id: contributionBody.id,
                        title: contributionBody.title,
                        code: contributionBody.code,
                        focus: contributionBody.focus,
                        section: contributionBody.section,
                        itemChanged: contributionBody.itemChanged
                    }
                };
            },
            netEffectContributionsAdapter.addOne
        ),
        netEffectContributionDeleted: create.reducer((state, action) => {
            const id = action.payload;
            netEffectContributionsAdapter.removeOne(state, id);
        }),
        netEffectContributionDeleteByIndex: (state, action) => {
            const indexToRemove = action.payload;
            state.contributions.splice(indexToRemove, 1);
        },
        netEffectContributionUpdated: create.reducer((state, action) => {
            const { id, title, code, focus, section, itemChanged } = action.payload;
            netEffectContributionsAdapter.updateOne(state,
                {
                    id, changes: {
                        title, code, focus, section, itemChanged
                    }
                })
        }),
        loadNetEffectContributions: create.reducer((state, action) => {
            netEffectContributionsAdapter.setAll(state, action.payload.netEffectContributions);
            state.status = "succeeded";
        })
    }),
    selectors: {
        selectNetEffectContributionsStatus: netEffectContributions => netEffectContributions.status
    }
})

export const { netEffectContributionAdded, netEffectContributionDeleted, netEffectContributionUpdated, loadNetEffectContributions } = netEffectContributionsSlice.actions

export const { selectNetEffectContributionsStatus } = netEffectContributionsSlice.selectors

export const {
    selectAll: selectAllNetEffectContributions,
    selectById: selectNetEffectContributionByTargetId,
} = netEffectContributionsAdapter.getSelectors(state => state.netEffectContributions)

export default netEffectContributionsSlice